import { createGlobalStyle, css } from 'styled-components';
import { Reset } from './reset';
import { SiteDocument } from './site-document';
import { FontFace } from './fonts/font-face';
import { mqMediumMin, mqLargeMin, mqXXLargeMin } from './tools/media-queries';
import { Fonts } from 'components/styles/fonts';
import { Elements } from 'components/styles/elements';
import { Layout } from 'components/styles/layout';
import { Forms } from 'components/styles/forms';
import { Tooltip } from 'components/styles/tooltip';
import { Accessibility } from 'components/styles/accessibility';
import { Vendor } from 'components/styles/vendor';
import { Print } from 'components/styles/print';

const Grid = css`
  :root {
    --space-columns: 4; // number of columns in a grid

    --grid-width: calc(100vw - (2 * var(--spacing-16)));
    --total-gutter: 3;
    --grid-col-width: calc(
      (var(--grid-width) - var(--total-gutter) * 20px) / var(--space-columns)
    );

    @media ${mqMediumMin} {
      --space-columns: 8;
      --total-gutter: 7;
      --grid-width: calc(100vw - (2 * var(--spacing-24)));
    }

    @media ${mqLargeMin} {
      --space-columns: 12;
      --total-gutter: 11;
      --grid-width: calc(100vw - (2 * var(--spacing-32)));
    }

    @media ${mqXXLargeMin} {
      --grid-width: 1440px;
    }
  }
`;

const RedesignFlagValues = css`
  :root {
    --flag-font-family: 'Seed Sans', Helvetica, sans-serif;
    --flag-border-radius: 99px;
    --flag-border-radius-points-badge: 99px;
    --flag-letter-spacing-1: -1%;
    --flag-letter-spacing-2: -2%;
    --flag-margin: calc((var(--spacing-48) + var(--spacing-8)) * -1);
    --flag-vaginal-margin: -30px;
    --flag-vaginal-padding: 0px;
    --flag-hero-padding: 0px;
    --flag-site-content-padding-top: 0;
    --flag-site-content-padding-top-2: 14px;
  }
`;

const GlobalStyle = createGlobalStyle<{
  $omitHydrationErrors?: boolean;
}>`
  ${Reset}
  ${FontFace}
  ${SiteDocument}
  ${Grid}
  ${RedesignFlagValues}

  ${Fonts}
  ${Elements}
  ${Layout}
  ${Forms}
  ${Tooltip}
  ${Accessibility}
  ${Vendor}
  ${Print}

  ${({ $omitHydrationErrors }) =>
    $omitHydrationErrors
      ? `
    nextjs-portal {
      display: none;
    }
    body {
      overflow: unset !important;
    }
  `
      : null}
`;
const BlankLayoutStyle = createGlobalStyle`
  ${FontFace}
  ${Fonts}
  ${Elements}
  ${Forms}
  ${Accessibility}
  ${Vendor}
  :root {
    --flag-font-family: 'Seed Sans', Helvetica, sans-serif;
    --flag-border-radius: 99px;
    --flag-border-radius-points-badge: 99px;
    --flag-letter-spacing-1: -1%;
    --flag-letter-spacing-2: -2%;
    --flag-margin: calc((var(--spacing-48) + var(--spacing-8)) * -1);
    --flag-vaginal-margin: -30px;
    --flag-vaginal-padding: 0px;
    --flag-vaginal-padding-mobile: 0px;
    --flag-hero-padding: 0px;
    --flag-site-content-padding-top: 0;
    --flag-site-content-padding-top-2: 14px;
  }
`;

export { GlobalStyle, BlankLayoutStyle };
